export type TSignUpDefaultEmail = {
	qrId: string
	previousEmail?: string
	draftEmail?: string
} | null

type TGetNextSignUpDefaultEmailParams = {
	onboardingQrId: string
	defaultEmail?: string
	previousEmail?: string
	watchedEmail: string
}

type TGetPayloadPreviousEmailParams = {
	storedDefaultEmail: TSignUpDefaultEmail
	onboardingQrId?: string | null
	previousEmail?: string
	defaultEmail?: string
}

export const getPayloadPreviousEmail = ({
	storedDefaultEmail,
	onboardingQrId,
	previousEmail,
	defaultEmail,
}: TGetPayloadPreviousEmailParams) => {
	if (!onboardingQrId || storedDefaultEmail?.qrId !== onboardingQrId) {
		return undefined
	}

	return previousEmail ?? defaultEmail
}

export const getNextSignUpDefaultEmail = (
	current: TSignUpDefaultEmail,
	{
		onboardingQrId,
		defaultEmail,
		previousEmail,
		watchedEmail,
	}: TGetNextSignUpDefaultEmailParams,
): TSignUpDefaultEmail => {
	const stablePreviousEmail =
		current?.qrId === onboardingQrId ? current.previousEmail : undefined

	const next = {
		qrId: onboardingQrId,
		previousEmail: stablePreviousEmail ?? previousEmail ?? defaultEmail,
		draftEmail: watchedEmail,
	}

	if (
		current?.qrId === next.qrId &&
		current.previousEmail === next.previousEmail &&
		current.draftEmail === next.draftEmail
	) {
		return current
	}

	return next
}
